import { Controller } from "@hotwired/stimulus"

// Кнопка "Сброс" в filter-bar (см. kit/_filter_bar.html.slim). Обычная
// ссылка на url без параметров делает полную Turbo-навигацию — это не
// сбрасывает визуальное состояние Choices.js (select_kit) и схлопывает
// раскрытый <details class="filter-bar">, т.к. на свежей странице у него
// нет атрибута open. Вместо навигации чистим поля прямо в DOM и пересабмичиваем
// форму в её текущий turbo-frame — без полной перезагрузки страницы.
export default class extends Controller {
  reset(event) {
    event.preventDefault()

    this.element.querySelectorAll(
      "input[type='text'], input[type='email'], input[type='search'], input[type='date'], input[type='number'], textarea"
    ).forEach(el => { el.value = "" })

    this.element.querySelectorAll("input[type='checkbox'], input[type='radio']").forEach(el => {
      el.checked = false
    })

    this.element.querySelectorAll("select").forEach(select => {
      if (select.choices) {
        select.choices.setChoiceByValue("")
      } else {
        select.value = ""
      }
    })

    this.element.requestSubmit()
  }
}
